import { DocumentType } from '../graphql/schema/p4types';

export const TRANSACTION_DETAILS_SUPPORTED_DOCUMENT_TYPES: Array<DocumentType> = [
  DocumentType.SalesInvoice,
  DocumentType.SalesCredit,
  DocumentType.SalesReceipt,
  DocumentType.SalesRefund,
  DocumentType.SalesOpeningBalanceInvoice,
  DocumentType.SalesOpeningBalanceCredit,
  DocumentType.SalesBadDebt,
  DocumentType.NominalJournal,
  DocumentType.NominalAccrual,
  DocumentType.NominalPrepayment,
  DocumentType.BankPayment,
  DocumentType.BankReceipt,
  DocumentType.BankTransfer,
  DocumentType.SalesVatInvoice,
  DocumentType.SalesVatCredit,
  DocumentType.PurchaseInvoice,
  DocumentType.PurchaseCredit,
  DocumentType.PurchaseVatInvoice,
  DocumentType.PurchaseVatCredit,
  DocumentType.PurchasePayment,
  DocumentType.PurchaseRefund,
  DocumentType.PurchaseOpeningBalanceInvoice,
  DocumentType.PurchaseOpeningBalanceCredit,
  DocumentType.PurchaseAllocation,
];
